import axios, { AxiosError, AxiosResponse } from "axios";
import { setUserData } from "../common/google-events";
import { NetworkError, UnexpectedError } from "./Errors";

export type FormDataObject = Record<string, unknown>;

type GoogleUsreData = {
  email?: string;
  first_name?: string;
  address?: {
    street?: string;
    postal_code?: string;
  };
};

export type FormOptions = {
  skipRecaptcha?: boolean;
  validateOnly?: boolean;
};

/**
 *
 *
 * @param url
 * @param data
 * @param options
 * @throws {NetworkError}
 * @throws {UnexpectedError}
 */
export async function sendFormData<T>(
  url: string,
  data: FormDataObject,
  options?: FormOptions
): Promise<T> {
  setUserData(mapFormDataToGoogleUserData(data));

  const params = new URLSearchParams();

  for (const key in data) {
    params.append(key, String(data[key] || ""));
  }
  params.append("page_url", location.href);

  if (options?.validateOnly) {
    params.append("validate_only", String(true));
  }

  if (options?.skipRecaptcha) {
    params.append("skipRecaptcha", String(true));
  }

  let result: AxiosResponse<T>;

  try {
    result = await axios.post(url, params);
  } catch (error) {
    if ((<AxiosError>error).response) {
      const err = <AxiosError>error;
      throw new NetworkError(
        "Received a network error response from server.",
        err.response?.status
      );
    }
    throw new UnexpectedError(`Reeived an unexpeted error. ${error}`);
  }

  return result.data;
}

function mapFormDataToGoogleUserData(data: FormDataObject): GoogleUsreData {
  return <GoogleUsreData>{
    email: data["email"] as string,
    first_name: data["name"] as string,
    address: {
      street: data["address"] as string,
      postal_code: data["postcode"] as string,
    },
  };
}
